<template lang="pug">
.container.mt-4.mt-sm-5.mb-6
    h1.mb-4 Häufig gestellte Fragen und Antworten

    .card.shadow-sm.bg-light.mb-4.p-4
        input.form-control.form-control-lg(v-model="search.query", placeholder="Fragen durchsuchen...")
        .form-inline.mt-3
            label.my-1.mr-3.font-weight-bold Filter:
            .custom-control.custom-control-inline.custom-radio(v-for="option in categoryOptions")
                input.custom-control-input(
                    type="radio",
                    :id="`categoryOption${option.value}`",
                    v-model="search.category",
                    :value="option.value"
                )
                label.custom-control-label(:for="`categoryOption${option.value}`") {{ option.text }}

    .card.shadow-sm
        .list-group.list-group-flush
            .list-group-item.py-4(v-for="item in itemList")
                h2 {{ item.question }}
                span(v-html="item.answer")
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleRight, faThumbsUp } from '@fortawesome/free-solid-svg-icons'

library.add(faAngleRight, faThumbsUp)

export default {
    data () {
        return {
            search: {
                query: '',
                category: false,
                categories: [
                    { id: 1, name: 'Softwarevoraussetzung und -verhalten' },
                    { id: 2, name: 'Datensicherheit und Datenschutz' },
                    { id: 3, name: 'Benutzer' },
                    { id: 4, name: 'Protokolle' }
                ]
            },
            items: [
                {
                    id: 1,
                    question: 'Kann ich die Software auch nutzen, wenn ich keine Fachkenntnisse habe?',
                    answer: '<p>Nein. Der Luftverbundrechner richtet sie ausschließlich an Fachleute. Eine Nutzung als Laie ist nicht empfohlen.</p>',
                    category: 1
                }, {
                    id: 2,
                    question: 'Wie werden Softwareaktualisierungen zur Verfügung gestellt? Sie diese kostenfrei?',
                    answer: '<p>Die Aktualisierungen des Programms erfolgen automatisch und sind immer kostenfrei. Sie werden über die Aktualisierung und deren Umfang, Funktionen per E-Mail-Newsletter benachrichtigt.</p>',
                    category: 1
                }, {
                    id: 3,
                    question: 'Welche technischen Anforderungen benötige ich, damit das Programm fehlerfrei arbeiten kann?',
                    answer: '<p>Der Luftverbundrechner läuft auf diesen Endgeräten oder neueren:</p>' +
                            '<ul>' +
                                '<li>AMD/Intel-PC oder Apple Mac mit 8GB Ram (Bj. 2013 und neuer)</li>' +
                                '<li>Apple iPhone ab iPhone 6s (Bj. 2013 und neuer)</li>' +
                                '<li>Apple iPad ab iPad Air (Bj. 2013 und neuer)</li>' +
                                '<li>Android Smartphone ab 4,8 Zoll Bildschirmdiagonale (Bj. 2015 und neuer)</li>' +
                                '<li>Android Tablet ab Bj. 2015</li>' +
                            '</ul>' +
                            '<p>Der Luftverbundrechner benötigt mindestens diese Betriebssysteme:</p>' +
                            '<ul>' +
                                '<li>Windows ab Version 8.1</li>' +
                                '<li>MacOS ab Version 10.9</li>' +
                                '<li>iOS ab Version 10.1</li>' +
                                '<li>Android ab Version 7</li>' +
                            '</ul>' +
                            '<p>Unter folgenden getesteten Browsern (und deren Nachfolgern) arbeitet der Luftverbundrechner optimal:</p>' +
                            '<ul>' +
                                '<li>Google Chrome ab 60</li>' +
                                '<li>MS Explorer ab 11</li>' +
                                '<li>Apple Safari ab 11</li>' +
                                '<li>Firefox ab 60</li>' +
                            '</ul>',
                    category: 1
                }, {
                    id: 4,
                    question: 'Gibt es eine mobile App für den Luftverbundrechner?',
                    answer: '<p>Derzeit leider noch nicht. Allerdings ist dieser Schritt als nächstes geplant. Wir informieren Sie über unseren E-Mail-Newsletter gerne über das Erscheinungsdatum, sobald dieses feststeht.</p>',
                    category: 1
                }, {
                    id: 5,
                    question: 'Was passiert, wenn ich den Browser einfach beende?',
                    answer: '<p>Ihr aktueller Arbeitsstand wird zwischengespeichert. Sie können das angefangene Protokoll unter “Entwürfe” erneut aufrufen und weiter bearbeiten.</p>',
                    category: 1
                }, {
                    id: 6,
                    question: 'Was passiert, wenn ich den Berechnungsassistenten abbrechen muss?',
                    answer: '<p>Ihr aktueller Arbeitsstand wird als Entwurf zwischengespeichert. Sie können das angefangene Protokoll unter “Entwürfe” erneut aufrufen und weiter bearbeiten.</p>',
                    category: 1
                }, {
                    id: 7,
                    question: 'Warum kann ich im privaten/Icognito-Modus eines mobilen Browsers das Programm nicht nutzen?',
                    answer: '<p>Derzeit wird die Funktionalität blockiert, um Daten im Offline-Modus lokal zwischenspeichern zu können. Wir arbeiten aber an einer Lösung.</p>',
                    category: 1
                }, {
                    id: 8,
                    question: 'Wie sicher sind meine Daten? Werden Sie doppelt gesichert?',
                    answer: '<p>Ihre Daten werden getrennt von den Daten anderer Kunden gespeichert. Die Übertragung vom Browser zum Rechenzentrum wird verschlüsselt. Ihre Daten werden redundant täglich auf ein zweites Backup-System gesichert.</p>',
                    category: 2
                }, {
                    id: 9,
                    question: 'Wo werden meine Daten gespeichert?',
                    answer: '<p>Wir arbeiten mit einem renommierten Hochsicherheits-Rechenzentrum in Frankfurt a. Main, Deutschland, zusammen, das nach den strengsten Richtlinien zertifiziert ist.</p>',
                    category: 2
                }, {
                    id: 10,
                    question: 'Wurde die IT-Sicherheit geprüft und gibt es dazu Zertifikate?',
                    answer: '<p>Unser gewählter Hosting-Anbieter arbeitet selbstverständlich nach dem internationalen Sicherheitsstandard ISO/IEC 27001.</p>',
                    category: 2
                }, {
                    id: 11,
                    question: 'Wie wird die Datenübertragung zum Webserver gesichert?',
                    answer: '<p>Die Sicherung erfolgt durch eine 256 Bit TLS-Verschlüsselung.</p>',
                    category: 2
                }, {
                    id: 12,
                    question: 'Wo kann ich meine persönlichen Daten ändern?',
                    answer: '<p>Rufen Sie im Programm “Einstellungen” auf. Wählen Sie dort Ihren “Benutzer” zum Bearbeiten. Hier können Sie Ihre persönlichen Daten bearbeiten.</p>',
                    category: 2
                }, {
                    id: 13,
                    question: 'Wie kann ich mein Konto mit allen Daten löschen?',
                    answer: '<p>Sie möchten Ihre Daten löschen? Schreiben Sie uns einfach eine Nachricht per E-Mail an support@luftverbundrechner.de mit dem Betreff “Datenschutz”. Wir werden uns umgehend um Ihr Anliegen kümmern und Ihnen Rückmeldung geben, sobald Ihre Anfrage bearbeitet wurde.</p>',
                    category: 2
                }, {
                    id: 14,
                    question: 'Können persönliche Daten auf Verlangen gelöscht werden?',
                    answer: '<p>Ja, das ist jederzeit möglich. Schreiben Sie uns einfach eine Nachricht per E-Mail an support@luftverbundrechner.de mit dem Betreff “Datenschutz”. Wir werden uns umgehend um Ihr Anliegen kümmern und Ihnen Rückmeldung geben, sobald Ihre Anfrage bearbeitet wurde.</p>',
                    category: 2
                }, {
                    id: 15,
                    question: 'Wie kann ich meine Daten exportieren?',
                    answer: '<p>Derzeit ist es dazu noch notwendig, dass Sie uns eine Nachricht per E-Mail an support@luftverbundrechner.de mit dem Betreff “Datenschutz” schicken. Wir werden uns umgehend um Ihr Anliegen kümmern und Ihnen Rückmeldung geben, sobald Ihre Anfrage bearbeitet wurde. Wir arbeiten aber an einer einfachen, komfortablen Export-Funktion.</p>',
                    category: 2
                }, {
                    id: 16,
                    question: 'Welche persönliche Daten werden gespeichert?',
                    answer: '<p>Wir speichern ausschließlich die Daten, die zur Nutzung unseres Programms und den Zahlungsverkehr notwendig sind.<br/>' +
                    'Dazu gehören:</p>' +
                    '<ul>' +
                        '<li>Firmenname</li>' +
                        '<li>Vor- und Nachname</li>' +
                        '<li>Rechnungsadresse</li>' +
                        '<li>E-Mail-Adresse des Kontoinhabers</li>' +
                        '<li>Benutzername (meist E-Mail-Adresse)</li>' +
                        '<li>Passwort (verschlüsselt)</li>' +
                        '<li>Optionale Firmenangaben (Telefon, Telefax, Mitarbeiteranzahl, Branche, USt-ID)</li>' +
                    '</ul>',
                    category: 2
                }, {
                    id: 17,
                    question: 'Welche Berechtigungsstufen für Benutzer gibt es? Wer darf was?',
                    answer: '<p>Wir unterscheiden drei grundsätzliche Berechtigungsstufen:</p>' +
                            '<ul>' +
                                '<li><strong>Techniker:</strong><br/>' +
                                    'Einfache Schreib- und Leseberechtigung für Protokolle</li>' +
                                '<li><strong>Meister:</strong><br/>' +
                                    'Wie Techniker + Freigabe von Protokollen, Löschen freigegebener Protokolle</li>' +
                                '<li><strong>Admin (Kontoinhaber)</strong><br/>' +
                                    'Wie Meister + Anlegen von Benutzern</li>' +
                            '</ul>',
                    category: 3
                }, {
                    id: 18,
                    question: 'Wie füge ich als Kontoinhaber weitere Benutzer bzw. Kollegen hinzu?',
                    answer: '<p>Gehen Sie im Programm in den Punkt “Einstellungen”. Dort finden Sie den Unterpunkt "Benutzerverwaltung", wo Sie weitere Benutzer hinzufügen können.</p>',
                    category: 3
                }, {
                    id: 19,
                    question: 'Warum kann ein Techniker keine Protokolle freigeben?',
                    answer: '<p>Wir setzen hier ganz bewusst auf das Vier-Augen-Prinzip. Eventuelle Fehler im Protokoll können so erkannt und korrigiert werden. Der Sicherheit zuliebe! Die Haftung und Verantwortung über die Richtigkeit des Protokolls übernimmt mit seiner Freigabe der Meister.</p>',
                    category: 3
                }, {
                    id: 20,
                    question: 'Wie kann ein Benutzer sein Passwort ändern?',
                    answer: '<p>Jeder Benutzer kann über das Programm über die Auswahl des Punktes “Einstellungen” und des Unterpunktes “Benutzerverwaltung” sein Passwort zurücksetzen bzw. ändern.</p>',
                    category: 3
                }, {
                    id: 21,
                    question: 'Was passiert mit den Protokollen, wenn ein Benutzer gelöscht wird?',
                    answer: '<p>Die Protokolle sind weiter unter dem Benutzernamen vorhanden und können vom Meister verwaltet werden.</p>',
                    category: 3
                }, {
                    id: 22,
                    question: 'Kann ich ein Protokoll nachträglich ändern?',
                    answer: '<p>Ja. Allerdings nur Protokolle, die noch in Bearbeitung und daher noch nicht abgeschlossen oder sogar freigegeben sind. Abgeschlossene und freigegebene Protokolle können nicht mehr verändert werden. Diese können aber als Vorlage für ein neues Protokoll kopiert werden.</p>',
                    category: 4
                }, {
                    id: 23,
                    question: 'Wie kann ich ein Protokoll freigeben?',
                    answer: '<p>Die Freigabe kann einfach in der Protokollverwaltung im jeweiligen Protokoll-Eintrag bestätigt werden. Die Freigabe kann aber nur mit entsprechenden Benutzerrechten getätigt werden.</p>',
                    category: 4
                }, {
                    id: 24,
                    question: 'Wie kann ich ein Protokoll versenden?',
                    answer: '<p>Bei der Nutzung des Programms am Desktop-PC ist das ganz einfach. Sichern Sie das PDF-Protokoll einfach lokal und versenden Sie es von diesem Speicherplatz aus per E-Mail. An der Lösung für mobile Endgeräte arbeiten wir mit Hochdruck.</p>',
                    category: 4
                }, {
                    id: 25,
                    question: 'Was bedeuten die Kurzbezeichnungen bzw. Abkürzungen der Räume im Protokoll?',
                    answer: '<ul>' +
                                '<li>AN = Anbau</li>' +
                                '<li>AR = Aufstellraum</li>' +
                                '<li>BL = Brennstofflagerraum</li>' +
                                '<li>BR = Betriebsraum/Werkstatt</li>' +
                                '<li>BÜ = Büro/Arbeitszimmer</li>' +
                                '<li>BZ = Badezimmer/Dusche</li>' +
                                '<li>DB = Dachboden/Speicherraum/Bodenraum</li>' +
                                '<li>EZ = Esszimmer</li>' +
                                '<li>FL = Flur/Treppenhaus/Diele</li>' +
                                // '<li>GA = Privatgarage</li>' +
                                '<li>GZ = Gästezimmer</li>' +
                                '<li>HA = Halle, Werk-, Industrie-, Logistik- oder Verkaufs-</li>' +
                                '<li>HW = Hauswirtschaftsraum</li>' +
                                '<li>JZ = Jugend-/ Kinderzimmer</li>' +
                                '<li>KR = Kellerraum</li>' +
                                '<li>KÜ = Küche</li>' +
                                '<li>LR = Lager- und Abstellraum</li>' +
                                '<li>SZ = Schlafzimmer</li>' +
                                '<li>TR = Technikraum/Hausanschlussraum</li>' +
                                '<li>VR = Verkaufsraum/Laden/Geschäft/Gastraum</li>' +
                                '<li>WC = Toilette</li>' +
                                '<li>WG = Wintergarten</li>' +
                                '<li>WZ = Wohnzimmer</li>' +
                                '<li>R1 = Raum 1</li>' +
                                '<li>R2 = Raum 2</li>' +
                                '<li>R3 = Raum 3</li>' +
                            '</ul>',
                    category: 4
                }, {
                    id: 26,
                    question: 'Was bedeuten die Kurzbezeichnungen bzw. Abkürzungen der Feuerstätten im Protokoll?',
                    answer: '<ul>' +
                                // '<li>BH = Blockheizkraftwerk <span class="text-muted small pl-2">(Gas, Fest, Flüssig)</span></li>' +
                                '<li>DW = Durchlaufwasserheizer <span class="text-muted small pl-2">(Gas)</span></li>' +
                                '<li>KW = Kombiwasserheizer <span class="text-muted small pl-2">(Gas)</span></li>' +
                                // '<li>WP = Wärmepumpe, Motor <span class="text-muted small pl-2">(Gas, Fest, Flüssig, Elektrisch)</span></li>' +
                                // '<li>HK = Heizkessel <span class="text-muted small pl-2">(Gas, Fest, Flüssig)</span></li>' +
                                '<li>UW = Umlaufwasserheizer <span class="text-muted small pl-2">(Gas)</span></li>' +
                                '<li>VW = Vorratswasserheizer/Badeofen <span class="text-muted small pl-2">(Gas)</span></li>' +
                                '<li>WA = Wärmepumpe, Adsorption <span class="text-muted small pl-2">(Gas)</span></li>' +
                                // '<li>WT = Wäschetrockner <span class="text-muted small pl-2">(Gas, Elektrisch)</span></li>' +
                                '<li>LE = Lufterhitzer <span class="text-muted small pl-2">(Gas, Flüssig)</span></li>' +
                                '<li>SO = Speicherofen - Grundofen <span class="text-muted small pl-2">(Fest)</span></li>' +
                                // '<li>GO = Speicherofen - Grundofen <span class="text-muted small pl-2">(Fest)</span></li>' +
                                // '<li>SG = Speicherofen - Specksteingrundofen <span class="text-muted small pl-2">(Fest)</span></li>' +
                                // '<li>KH = Speicherofen - Kachelofen mit Heizeinsatz <span class="text-muted small pl-2">(Fest)</span></li>' +
                                '<li>KO = Kaminofen <span class="text-muted small pl-2">(Fest)</span></li>' +
                                // '<li>OK = Offener Kamin <span class="text-muted small pl-2">(Fest)</span></li>' +
                                '<li>KE = Kamineinsatz, Kaminkassette <span class="text-muted small pl-2">(Fest)</span></li>' +
                                '<li>RH = Raumheizer <span class="text-muted small pl-2">(Fest, Gas)</span></li>' +
                                '<li>HE = Heizherd/Heizungsherd <span class="text-muted small pl-2">(Fest)</span></li>' +
                                // '<li>HK = Heizkessel <span class="text-muted small pl-2">(Fest)</li>' +
                                // '<li>FC = Brennstoffzelle (Fuel Cell) <span class="text-muted small pl-2">(Flüssig)</span></li>' +
                                // '<li>BA = Backofen/Pizzaofen <span class="text-muted small pl-2">(Elektrisch)</span></li>' +
                                // '<li>BO = Brennofen <span class="text-muted small pl-2">(Elektrisch)</span></li>' +
                                // '<li>SD = Dunkelstrahler <span class="text-muted small pl-2">(Elektrisch)</span></li>' +
                                // '<li>WM = Waschmaschine <span class="text-muted small pl-2">(Elektrisch)</span></li>' +
                                '<li>MF = Mehrere Feuerstätten <span class="text-muted small pl-2">(Gas, Fest)</span></li>' +
                            '</ul>',
                    category: 4
                }, {
                    id: 27,
                    question: 'Wie können Kollegen auf meine Protokolle zugreifen?',
                    answer: '<p>Von Anfang an können alle Benutzer unter einem Konto die erstellten Protokolle in ihrem Protokollverlauf sehen und danach filtern bzw. suchen.</p>',
                    category: 4
                }, {
                    id: 28,
                    question: 'Kann ich ein gelöschtes Protokoll wiederherstellen?',
                    answer: '<p>Gelöschte Protokolle können bis zu 30 Tage nach Löschung wiederhergestellt werden. Danach ist dies leider nicht mehr möglich.</p><p>Um eine Wiederherstellung anzufragen, schreiben Sie uns einfach eine Nachricht per E-Mail an support@luftverbundrechner.de mit dem Betreff "Protokoll wiederherstellen". Wir werden uns umgehend um Ihr Anliegen kümmern und Ihnen Rückmeldung geben, sobald Ihre Anfrage bearbeitet wurde.</p>',
                    category: 4
                }, {
                    id: 29,
                    question: 'Was ist der Unterschied zwischen begonnenen, abgeschlossenen und freigegebenen Protokollen?',
                    answer: '<ul>' +
                                '<li><strong>Begonnene Protokolle</strong> sind solche, die neu erstellt wurden, sich aber noch in Bearbeitung befinden und im Entwurf-Modus gespeichert wurden.</li>' +
                                '<li><strong>Abgeschlossene Protokolle</strong> sind solche, die der Ersteller zur Freigabe bereitgestellt hat.</li>' +
                                '<li><strong>Freigegebene Protokolle</strong> sind solche, die vom Ersteller und Meister geprüft und als freigegeben markiert wurden und damit nicht mehr verändert werden können.</li>' +
                            '</ul>',
                    category: 4

                }
            ]
        }
    },
    computed: {
        categoryOptions: function () {
            // create options by categories
            let options = this.search.categories.map(category => {
                let numItems = this.items.filter(item => { return item.category === category.id }).length
                return {
                    text: category.name + ' (' + numItems + ')',
                    value: category.id
                }
            })
            // add "all" option
            options.unshift({
                text: 'Alle (' + this.items.length + ')',
                value: false
            })

            return options
        },
        itemList: function () {
            return this.items.filter(item => {
                if (this.search.category && item.category !== this.search.category) {
                    return false
                }
                if (!this.search.query) {
                    return true
                }
                if (item.question.toLowerCase().includes(this.search.query.toLowerCase())) {
                    return true
                }
                if (item.answer.toLowerCase().includes(this.search.query.toLowerCase())) {
                    return true
                }
                return false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

h2 {
    font-size: 1.25rem;
    font-weight: 500;
    margin-bottom: 1rem;
}
</style>
